export default __webpack_public_path__ + "static/media/Gotham-Book.4e829221.ttf";